import script from "./CustomerContent.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerContent.vue?vue&type=script&setup=true&lang=js"

import "./CustomerContent.vue?vue&type=style&index=0&id=50dbafdd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50dbafdd"]])

export default __exports__